import { STATS } from "../../lib/site";
import { ArrowUpRight } from "lucide-react";

export default function CaseStudy() {
  return (
    <section
      data-testid="case-study-section"
      className="bg-[#00C2B8] border-y-2 border-[#1A1A1A] relative overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 lg:px-12 py-20 md:py-28">
        <div className="max-w-4xl">
          <p className="font-mono text-xs tracking-[0.25em] uppercase">
            Case Study · The Proof
          </p>
          <h2 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tighter text-[#1A1A1A]">
            Powered by real-world proof.
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#1A1A1A]/90 font-medium leading-relaxed">
            TinkerShift is powered by TinkerTank — a hands-on learning
            company with 10 years of delivery experience and more than 15,000
            students reached through creative technology, STEM, animation,
            robotics, coding, design and maker learning.
          </p>
        </div>

        {/* Stats grid */}
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              data-testid={`stat-${i}`}
              className={`bg-white border-2 border-[#1A1A1A] rounded-3xl p-6 md:p-7 nb-shadow ${
                i % 2 === 1 ? "md:translate-y-4" : ""
              }`}
            >
              <p className="font-display font-black text-4xl md:text-5xl lg:text-6xl leading-none tracking-tighter">
                {s.value}
              </p>
              <p className="mt-3 text-sm md:text-base font-semibold text-[#1A1A1A]/80">
                {s.label}
              </p>
            </div>
          ))}
        </div>

        {/* Case study card */}
        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6 items-stretch">
          <div className="lg:col-span-7 bg-[#1A1A1A] text-white rounded-3xl border-2 border-[#1A1A1A] p-8 md:p-10 nb-shadow-lg">
            <p className="font-mono text-xs uppercase tracking-widest text-[#FFD700]">
              Featured Case Study
            </p>
            <h3 className="mt-3 font-display font-black text-3xl md:text-4xl leading-tight tracking-tighter">
              TinkerTank × Libraries
            </h3>
            <p className="mt-4 text-white/80 font-medium leading-relaxed max-w-xl">
              From underused spaces to thriving student programs, TinkerTank
              has helped activate creative learning environments through
              regular workshops, holiday programs and community engagement.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {["Makerspace", "Holiday Programs", "Staff Training", "Community"].map(
                (tag) => (
                  <span
                    key={tag}
                    className="text-[11px] font-mono uppercase tracking-widest border border-white/30 rounded-full px-3 py-1"
                  >
                    {tag}
                  </span>
                ),
              )}
            </div>
            <a
              href="/contact"
              data-testid="case-study-cta"
              className="mt-8 inline-flex items-center gap-2 bg-[#FFD700] text-[#1A1A1A] border-2 border-[#FFD700] rounded-full px-5 py-3 font-bold uppercase text-sm tracking-wide nb-press"
            >
              Talk to us about your space{" "}
              <ArrowUpRight size={16} strokeWidth={2.5} />
            </a>
          </div>

          <div className="lg:col-span-5 bg-[#FFD700] rounded-3xl border-2 border-[#1A1A1A] p-8 nb-shadow-lg flex flex-col justify-between">
            <p className="font-display font-black text-3xl md:text-4xl leading-tight tracking-tighter text-[#1A1A1A]">
              “TinkerTank turned our makerspace into the busiest, most loved
              room in the whole library.”
            </p>
            <div className="mt-6 flex items-center gap-3">
              <div className="h-10 w-10 rounded-full bg-[#FF007F] border-2 border-[#1A1A1A]" />
              <div>
                <p className="font-bold text-sm">Library partner</p>
                <p className="text-xs font-mono uppercase tracking-widest">
                  Community engagement lead
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
